import React, { useState, useEffect } from 'react'

import {
    StyledListItem,
    StyledRelatedContent,
    StyledRelatedContentContainer,
    StyledSectionHeader,
    StyledIconPremium,
} from 'component-library/content/RelatedContent/RelatedContent.styled'
import { toLinkWithHint } from 'common/routing/route-hints'
import { StyledTextLink } from 'component-library/typography/TextLink/TextLink.styled'
import { ImpressionAvailable } from 'component-library/__helpers/impression-available-helper'
import { PublicationCardItem } from 'common/client-data-types/card-types'
import {
    createCardClickedEvent,
    createCollectionAvailableEvent,
} from 'common/events/collection-events'
import { PublicationEvents } from 'common/events/publication-events'

export interface Props {
    items: PublicationCardItem[]
    onEvent: (event: PublicationEvents) => void
    title?: string
}

let sortFunc = () => 0.5 - Math.random()

// The randomisation is problematic in testing so we make it less random
if (
    process &&
    process.env &&
    (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'vr_test')
) {
    sortFunc = () => 0
}

const shuffleAndSlice = (items: PublicationCardItem[]) => [...items].sort(sortFunc).slice(0, 3)

export const RelatedContent: React.FC<Props> = ({ items, onEvent, title }) => {
    const [relatedContent, setRelatedContent] = useState<PublicationCardItem[]>(
        shuffleAndSlice(items)
    )

    useEffect(() => {
        setRelatedContent(shuffleAndSlice(items))
    }, [items])

    const ListItems = relatedContent.map<JSX.Element>((item, index) => {
        return (
            <StyledListItem key={index}>
                <StyledTextLink
                    to={toLinkWithHint({ loaded: true, result: item })}
                    onClick={() => {
                        onEvent(
                            createCardClickedEvent(
                                item,
                                'RelatedContent',
                                'List',
                                index,
                                'relatedcontent'
                            )
                        )
                    }}
                >
                    {item.shortHeadline}
                </StyledTextLink>
                {item.isPremium && <StyledIconPremium />}
            </StyledListItem>
        )
    })

    const ListType = <StyledRelatedContent>{ListItems}</StyledRelatedContent>

    return (
        <ImpressionAvailable
            loading={false}
            available={() => {
                onEvent(
                    createCollectionAvailableEvent(relatedContent, 'RelatedContent', {
                        componentType: 'relatedcontent',
                    })
                )
            }}
        >
            {ref => (
                <StyledRelatedContentContainer ref={ref}>
                    <StyledSectionHeader
                        heading={title ? title : 'From around the site'}
                        section="default"
                        fontScale={1}
                    />
                    {ListType}
                </StyledRelatedContentContainer>
            )}
        </ImpressionAvailable>
    )
}
